import React from "react";

export const SkipToContent = () => (
    <a
        href="#main-content"
        className="skip-link"
        data-testid="skip-to-content"
    >
        Skip to main content
    </a>
);

export default SkipToContent;
